module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMVJREFUOE9jZCATMOLSFzr1Pw9IbnU24xdsanBqDJn1fzNIw5o0Rl+iNQZN/5/AxMzQD9Lw/x9D7toMxiXomnHbOPt/PdjGVMZGom0EKQwZnBqDZv+XYf7PcHh1GqMizD8hs//7Q/24ESYWOuv//b+MDLbrUhmfgAMnYPp/BVZmhv3IGrEFCEjj778MjhsyGR8ga7z+n4HhBL6ExMjAYPH7L4MmXCNIceiM/yEMTAzg1IIT/GP4sjqDcQ1IHmc8EkrCZGsEAEjGSA/IgW9kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/imgs/release/upload.png
// module id = TDhZ
// module chunks = 0